import classes from "./IntroPicture.module.css";
import { AppHelper } from "../../App";

import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

function IntroPicture(props) {
  const navigate = useNavigate();

  const imgpath = `${AppHelper.storageUrl}media/domifederowicz_foto.jpg`;

  useEffect(() => {
    setTimeout(() => {
      navigate("/selection", { replace: true });
    }, 3000);
  }, []);

  return (
    <div className={classes.main}>
      <Link to="/selection">
        <img className={classes.img} alt="" width="625" src={imgpath}></img>
      </Link>
    </div>
  );
}

export default IntroPicture;
